// src/utils/validators.js

import { PhoneNumberUtil } from 'google-libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();

export const isPhoneValid = (phone) => {
  // No validar si el valor es nulo, indefinido o demasiado corto
  if (!phone || phone.length < 10) {
    return false;
  }

  try {
    const parsedNumber = phoneUtil.parseAndKeepRawInput(phone);
    return phoneUtil.isValidNumber(parsedNumber);
  } catch (error) {
    // La librería lanza un error si el formato es completamente incorrecto
    return false;
  }
};